import React from 'react'
import styles from './CourseGridContainer.module.css';
const CourseGridContainer = (props)=>{
    return (
        <div className={[styles.CourseGridContainer, props.className].join(' ')}>
            {props.children}
        </div>
    )
}
export default CourseGridContainer;